export enum UnitSystem {
  METRIC = 'metric',
  IMPERIAL = 'imperial',
}

export enum MeasurementType {
  MASS = 'mass', // Handled as mass rate (kg/h)
  VOLUME = 'volume', // Handled as flow rate (scf/h)
}

export enum TimeUnit {
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
}

export type UnitConfig = {
  system: UnitSystem
  type: MeasurementType
  timeUnit?: TimeUnit
  isTotal?: boolean // Indicates if the unit is for total emissions
  methaneDensity?: number // kg/m³ - Methane density for volume/mass conversions
}

export type UserPreferencesUnitConfig = {
  unitSystem: UnitConfig['system']
  measurementType: UnitConfig['type']
  timeUnit: UnitConfig['timeUnit']
  methaneDensity?: number // kg/m³ - Methane density for volume/mass conversions
}
